import { RefreshAutoIcon } from './RefreshAutoIcon';

/**
 * author: Michael Irigoyen
 * id AD1242A1-160E-4DF0-9E29-15F0A0ECF974
 * name refresh-auto
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/refresh-auto.svg
 * tags
 * - Automotive 
 */
export const AutoStopIcon = RefreshAutoIcon;
export default AutoStopIcon